export default __webpack_public_path__ + "static/media/T560_CoC.dbd8f83d.pdf";